import { computed, Directive, inject, input } from '@angular/core';
import { KexpDialogsService } from '../../../services/dialogs.service';
import { ShowAndSegmentNamerController } from '@splixer/player-ui';
import { uString } from '@hidat/huijs-common';

@Directive()
export class TrackCardController extends ShowAndSegmentNamerController {
  public readonly eventSource = input.required<string | null>();

  protected dialogService = inject(KexpDialogsService);
  protected useThumbnail = false;

  protected content = computed(() => {
    return this.item()?.content;
  });

  protected npImageUrl = computed(() => {
    const np = this.item();
    if (np) {
      return this.station.getTimelineImageUrl(np, this.useThumbnail);
    }
    return undefined;
  });

  protected npImageLabel = computed(() => {
    const np = this.item();
    if (np?.content) {
      return this.station.getTimelineImageLabel(np, true);
    }
    return '';
  });

  protected hasShow = computed(() => {
    return !!this.item()?.show;
  });

  protected showName = computed(() => {
    let name: uString;
    const np = this.item();
    if (np) {
      name = this.showNameFromTimeline(np);
    }
    return name;
  });

  trackInfoEvent = () => {
    const si = this.item();
    if (si) {
      this.dialogService.showTrackInfoDialog(si, this.eventSource());
    }
  };

}
